<template>
  <div class="capital-account-init-detail">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="BaseInfo" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t(`基本信息`)"></a-tab-pane>
          <a-tab-pane key="AmountInfo" :tab="$t(`账户余额信息`)"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct" v-show="!loading">
          <OperateBtn
            v-if="formData.status === 'WAIT_CHECK'"
            api="checkCapitalInit"
            :text="$t('审核')"
            :params="{
              idList: [id],
            }"
            @success="init"
          />
          <!-- <OperateBtn
            class="ml10"
            v-if="isDetail && ['DRAFT', 'WAIT_CHECK', 'WAIT_PAY'].includes(formData.status)"
            api="operateAssetImpairment"
            type="danger"
            :text="$t('作废')"
            :params="{
              action: 'DELETE',
              idList: [id],
            }"
            @success="init"
          /> -->
        </div>
      </div>
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <ModalBox id="BaseInfo" :title="$t('基本信息')">
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`单据编号`)">
                    <a-input disabled v-model="formData.orderSn"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算组织`)" required>
                    <CommonSelect
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :placeholder="$t('结算组织')"
                      :disabled="isDetail"
                      :code.sync="formData.businessUnitCode"
                      :name.sync="formData.businessUnitName"
                      @change="changeBU"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`启用期间`)" required>
                    <CommonQuerySelect
                      api="queryAccountingCalendarDetailPage"
                      valueName="accounting_period_code"
                      labelName="accounting_period_name"
                      :code.sync="formData.accountingPeriod"
                      :placeholder="$t(`启用期间`)"
                      :disabled="isDetail"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`本位币`)" required>
                    <SelectCurrency :code="formData.functionalCurrency" :disabled="true" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`状态`)">
                    <a-input
                      :value="$store.getters.initCapitalBalanceStatusMapping[formData.status]"
                      :disabled="true"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
            <ModalBox id="AmountInfo" :title="$t('账户余额信息')">
              <template v-slot:header>
                <div class="option-btns pr20" v-if="!isDisabled">
                  <span class="text-link fz16" @click="addLineHandle({})">
                    {{ $t('增行') }}
                  </span>
                  <span class="text-link fz16 ml10" @click="deleteAccount">
                    {{ $t('删行') }}
                  </span>
                </div>
              </template>

              <CommonTable
                :columns.sync="columns"
                :dataSource="formData.detailList"
                :selectedRowKeys.sync="selectedRowKeys"
                :showSelect="!isDisabled"
                :scroll="{ x: 1200 }"
                :showPagination="false"
              >
                <template v-slot:name="{ text, record, index }">
                  <a-input
                    :value="text || record.capitalAccountName"
                    :disabled="isDisabled"
                    readOnly
                    @click="showAccountModal(index)"
                  />
                </template>
                <template v-slot:balance="{ record }">
                  <PriceInput
                    :value.sync="record.balance"
                    :disabled="isDisabled"
                    :currency="record.currency"
                  />
                </template>
                <template v-slot:settlementMethod="{ record }">
                  <SelectSettlementMethod
                    :placeholder="$t(`结算方式`)"
                    :code.sync="record.settlementMethod"
                    :disabled="isDisabled"
                  />
                </template>
              </CommonTable>
            </ModalBox>
          </a-form-model>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>
      <BottomBtns
        :isEdit.sync="isEdit"
        :isDetail="isDetail"
        :draftLoading="draftLoading"
        :saveLoading="saveLoading"
        :status="formData.status"
        @submit="onSubmit"
        @cancel="getDetailInfo"
        @back="backForm"
      />
    </a-spin>

    <SelectCapitalAccountModal
      ref="CapitalAccountModal"
      :businessUnitCode="formData.businessUnitCode"
      @ok="handleAssetCardOk"
    ></SelectCapitalAccountModal>
  </div>
</template>

<script>
import moment from 'moment'
import http from '@/service/axios'
import api from '@/service/api'
import BottomBtns from '@component/bottomBtns'
import OperationLog from '@component/operationLog'
import SelectCurrency from '@component/selectCurrency'
import SelectCapitalAccountModal from '@component/selectCapitalAccountModal'
import deepClone from '@/common/deepClone'
import debounce from '@/common/debounce'
import { convertKeysToCamelCase, goBack } from '@/common'
export default {
  name: 'CapitalAccountInitDetail',
  components: { BottomBtns, OperationLog, SelectCurrency, SelectCapitalAccountModal },
  data() {
    return {
      docType: 'CapitalAccountInit',
      id: undefined,
      sn: undefined,
      isDetail: false, //是否是详情页
      isEdit: false, //是否编辑状态
      formData: {
        businessUnitCode: undefined,
        businessUnitName: undefined,
        status: 'DRAFT',
        detailList: [],
      },
      loading: false,
      draftLoading: false,
      saveLoading: false,
      selectedRowKeys: [],

      isReturn: true,
      columns: [],
      tableIndex: 0,
    }
  },
  activated() {
    this.init()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  watch: {
    'formData.businessUnitCode'(val, oldVal) {
      if (oldVal && val !== oldVal && !this.isReturn && !this.isDetail) {
        this.$confirm({
          title: this.$t('组织切换，将清除单据信息，是否确认切换？'),
          onOk: () => {
            this.formData.detailList = []
          },
          onCancel: () => {
            this.isReturn = true
            this.formData.businessUnitCode = oldVal
            this.formData.businessUnitName = undefined
          },
        })
      } else {
        this.isReturn = false
      }
    },
  },
  computed: {
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    scrollHeight() {
      return window.innerHeight - 280 + 'px'
    },
  },
  methods: {
    init() {
      this.isDetail = false
      this.isEdit = false
      if (!this.$route.query.id) {
        Object.assign(this.$data, this.$options.data())
        this.formData.accountingPeriod = moment().format('YYYY-MM')
      } else {
        this.isDetail = true
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.$nextTick(() => {
          this.$refs.OperationLogRef.queryList()
        })
      }
      this.getDetailInfo()
      this.columns = [
        {
          title: this.$t('银行账号'),
          dataIndex: 'bankCode',
          width: 200,
          customRender: (text, record) => text || record.capitalAccountCode,
        },
        {
          title: this.$t('账户名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('组织'),
          dataIndex: 'businessUnitName',
          customRender: (text) => text || this.formData.businessUnitName,
        },
        {
          title: this.$t('结算方式'),
          dataIndex: 'settlementMethod',
          scopedSlots: { customRender: 'settlementMethod' },
          width: 200,
        },
        {
          title: this.$t('币别'),
          dataIndex: 'currency',
          customRender: (text) => this.$store.getters.currencyListMapping[text],
        },
        {
          title: this.$t('期初余额'),
          dataIndex: 'balance',
          scopedSlots: { customRender: 'balance' },
          width: 200,
        },
      ]
    },
    changeBU(value) {
      this.formData.functionalCurrency = value.currency
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    async getDetailInfo() {
      let capitalAccount = localStorage.getItem('capitalAccount')
      if (this.id) {
        this.loading = true
        await http({
          url: api.getCapitalInitDetail,
          data: {
            id: this.id,
          },
          success: (res) => {
            let result = convertKeysToCamelCase(res.result)
            this.formData = {
              ...this.formData,
              ...result,
            }
            if (result.status === 'DRAFT') {
              this.isEdit = true
            }
          },
        })
        this.loading = false
      } else if (capitalAccount) {
        capitalAccount = JSON.parse(capitalAccount)
        this.handleAssetCardOk([capitalAccount])
        localStorage.removeItem('capitalAccount')
      }
    },
    backForm(back = 0) {
      goBack('capitalAccountInitList', back)
    },
    onSubmit: debounce(async function (status) {
      const data = deepClone(this.formData)
      data.status = status
      if (this.id) {
        data.id = this.id
      }
      if (status === 'DRAFT') {
        this.draftLoading = true
      } else {
        this.saveLoading = true
        // 校验 detailList 中账户名称和结算方式必填
        for (let i = 0; i < data.detailList.length; i++) {
          const item = data.detailList[i]
          const accountName = item.name || item.capitalAccountName
          if (!accountName) {
            this.$message.error(this.$t(`第${i + 1}行账户名称不能为空`))
            this.saveLoading = false
            return
          }
          if (!item.settlementMethod) {
            this.$message.error(this.$t(`第${i + 1}行结算方式不能为空`))
            this.saveLoading = false
            return
          }
        }
      }
      data.detailList = data.detailList.map((item) => ({
        balance: item.balance,
        capitalAccountCode: item.code || item.capitalAccountCode,
        capitalAccountId: item.id,
        capitalAccountName: item.name || item.capitalAccountName,
        currency: item.currency,
        initCapitalBalanceId: item.initCapitalBalanceId,
        settlementMethod: item.settlementMethod,
      }))
      try {
        await http({
          url: api.createOrUpdateCapitalInit,
          data,
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              this.$success({
                title: this.$t(`成功`),
                content: this.$t(`保存成功`),
              })
              if (this.isDetail) {
                this.init()
              } else {
                this.backForm()
              }
            } else {
              this.$error({
                title: this.$t(`错误`),
                content: this.$t(`创建失败`),
              })
            }
          },
        })
      } finally {
        this.draftLoading = false
        this.saveLoading = false
      }
    }),
    showAccountModal(index) {
      this.tableIndex = index
      this.$refs.CapitalAccountModal.open()
    },
    addLineHandle(params) {
      this.formData.detailList.push(params)
    },
    deleteAccount() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t(`至少选中一项`))
        return
      }
      this.formData.detailList = this.formData.detailList.filter(
        (item, index) => !this.selectedRowKeys.includes(index)
      )
      this.selectedRowKeys = []
    },
    handleAssetCardOk(list) {
      this.$set(this.formData.detailList, this.tableIndex, list[0])
      if (list.length > 1) {
        //除了第一个 剩下的循环调用addLineHandle
        list.slice(1).forEach((item) => {
          this.addLineHandle(item)
        })
      }
      this.$refs.CapitalAccountModal.close()
    },
  },
}
</script>
